import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { TableCell, TableHeadCell, TableRow, TableHeadRow } from 'src/components/MainTable/MainTable.style';


export const HeaderWrapper = styled('div', { label: 'HeaderWrapper' })`
    display: flex;
    background-color: transparent;
    padding: 5px 6px;
`;

export const HeaderItem = styled('div', { label: 'HeaderItem' })`
    margin-right: 15px;
`;

export const HeaderTitle = styled('h4', { label: 'HeaderTitle' })`
    color: ${mainColors.main.primary};
    display: inline;
    font-size: 12px;
    margin: 0 4px 0 0;
    line-height: 1.3;
`;

export const HeaderText = styled('span', { label: 'HeaderText' })`
    font-size: 12px;
    color: ${mainColors.main.primary};
    margin: 0;
    line-height: 1.3;
`;

interface NetDepositTableTabType {
    isCustomerTab: boolean;
    valueType?: 'positive' | 'negative' | 'zero';
    isUnderButton?: boolean;
}

export const MainTableHeadCellWrapper = styled(TableHeadCell, { label: 'MainTableHeadCellWrapper' }) <NetDepositTableTabType>`
    background-color:  ${({ isCustomerTab }): string => isCustomerTab === true ? `${mainColors.grays.gray200}` : 'transparent' };
    max-width: 160px;
    min-width: 140px;
    display: flex;
    justify-content: center;
    flex: 1 1 35px;
    align-items: center;
}

`;

export const buildCheckboxType = (isCustomerTab: boolean, valueType: 'positive' | 'negative' | 'zero' | undefined): string => {
    if (isCustomerTab === true && valueType ==='positive' ) {
        return `
            background-color: #008800;
            color: ${mainColors.text.light}
        `;
    } else if (isCustomerTab === true && valueType ==='negative'){
        return `
            background-color: ${mainColors.status.error};
            color: ${mainColors.text.light}
        `;
    }
      return `
            background-color: transparent;
        `;
};

export const MainTableCellWrapper = styled(TableCell, { label: 'MainTableCellWrapper' }) <NetDepositTableTabType>`
    ${({ isCustomerTab, valueType }): string => isCustomerTab === true ? buildCheckboxType(isCustomerTab, valueType) : 'transparent' };
    min-width: ${({ isUnderButton }): string => isUnderButton === true ? '178px' : '160px' };
    flex: 1 1 34px;
    text-align: center;

    &:last-of-type {
        border-right: 1px solid ${mainColors.text.light};
    }
`;

export const ShowMoreWrapper = styled('div', { label: 'ShowMoreWrapper' })`
    align-self: center;
    margin-left: 10px;
`;


export const MainTableRowWrapper = styled(TableRow, { label: 'MainTableRowWrapper' })`
   background-color: transparent;
`;

export const MainTableHeadRowWrapper = styled(TableHeadRow, { label: 'MainTableHeadRowWrapper' })`
   background-color: transparent;
`;

export const NetDepositContainer = styled('div', { label: 'NetDepositContainer' })`
    overflow: scroll;
`;

